module.exports = __webpack_public_path__ + "@/assets/img/logo-youtube.76a10535.png";